'use strict';

var ContributingFBGsGridTransformerFactory = function ContributingFBGsGridTransformerFactory(DataTransformer) {
  function ContributingFBGsGridTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'fares-mode';
    this.targetType = 'contributing-fbgs';
    this.priority = 1;
  }
  ContributingFBGsGridTransformer.prototype = Object.create(DataTransformer.prototype);
  ContributingFBGsGridTransformer.constructor = ContributingFBGsGridTransformer;
  ContributingFBGsGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  ContributingFBGsGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  ContributingFBGsGridTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  return ContributingFBGsGridTransformer;
};
ContributingFBGsGridTransformerFactory.$inject = ['ContributingFBCsGridTransformerFactory'];
module.exports = ContributingFBGsGridTransformerFactory;